export default __webpack_public_path__ + "static/media/KZ.Т.12.2529 Syrdarya black.bdfef7d4.svg";